import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter, formattedNumberValueGetter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { QUARTILE_VIDEO_REPORT_ID } from './quartileVideoReportId';

const quartileReportColumnDefinition = [
    {
        headerName: FIELDS.QUARTILE.label,
        field: FIELDS.QUARTILE.field,
        type: [leftPinnedColumn],
        cellRenderer: FIELDS.QUARTILE.cellRenderer,
        cellRendererParams: FIELDS.QUARTILE.renderParams,
        csvValueGetter: FIELDS.QUARTILE.csvValueGetter,
    },
    ...[FIELDS.VIDEO_IMPRESSIONS, FIELDS.QUARTILE_IMPRESSIONS_RATE].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(quartileReportColumnDefinition, QUARTILE_VIDEO_REPORT_ID);
